import React from 'react';
import { Button } from 'react-bootstrap';
import { images } from 'utils';

const UploadTo3PlBanner = (props) => {
	return (
		<div id="UploadTo3PlBanner" className="upload-menu-banner bg-white">
			<img src={images.WarningIcon} alt="WarningIcon" className="pointer" />
			<div style={{ fontSize: '16px', textAlign: 'center' }}>
				Your changes have been saved. Don't forget to upload to 3PL
			</div>
			<div style={{ display: 'flex', gap: 4 }}>
				<Button
					className="btn btn-danger btn-lg"
					type="submit"
					onClick={props.upload}
				>
					Upload to 3PL
				</Button>
			</div>
		</div>
	);
};

export default UploadTo3PlBanner;
